import { render, staticRenderFns } from "./RegisterOrgForm.vue?vue&type=template&id=46b595eb&"
import script from "./RegisterOrgForm.vue?vue&type=script&lang=js&"
export * from "./RegisterOrgForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOrgForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports